import { PermissionsScope } from '../../policies/policy.model'
import { SelectionData } from '../../../models/util.model'
import { ActivityTab } from '../models/activity.types'

export const ACTIVITY_FRAGMENT = 'activity'
export const ACTIVITY_SCOPE: PermissionsScope = 'activities'
export const ACTIVITY_TABS: SelectionData<ActivityTab>[] = [
  {
    value: 'data',
    label: 'Data',
  },
  {
    value: 'notification',
    label: 'Notification',
  },
  {
    value: 'configuration',
    label: 'Configuration',
  },
]
export const DEFAULT_CRON_EXPRESSION = '* * * * *'

export const minutes: number[] = new Array(60).fill(1).map((x, i) => i)
export const hours: number[] = new Array(24).fill(1).map((x, i) => i)
export const days: number[] = new Array(31).fill(1).map((x, i) => i + 1)
export const months: string[] = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
]
export const weekdays: string[] = [
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
]
